/* eslint no-return-assign: "off", max-len: "off" */
import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';

import languageNames from '../modules/iso6391names';

const url =`${process.env.REACT_APP_API_URL}/translate/`;

/* Displays translation controls and the translation itself for the currently visible text. */

class Translation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      target: 'en',
      loading: false,
      translation: {},
      supportedLanguages: [],
    };
  }

  componentDidMount() {
    this.getSupportedLanguages();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.language != this.props.language) {
      this.getSupportedLanguages();
    }
  }

  translate = async () => {
    const { text } = this.props;
    this.setState({ loading: true });

    if (this.props.text.activeText === null) {
      return;
    }

    if (
      text.texts[text.activeText].translations &&
      text.texts[text.activeText].translations[this.state.target]
    ) {
      this.setState({
        loading: false,
        translation: {
          text: text.texts[text.activeText].translations[this.state.target],
        },
      });
      return;
    }

    const sourceText = text.texts[this.props.text.activeText].source;

    const source_language = this.props.source.substring(0, 2);

    const data = {
      text: sourceText,
      source_language,
      target_language: this.state.target,
    };

    fetch(url, {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then((json) => {
        this.setState({ loading: false, translation: json.translation });
        const translation = {};
        translation[this.state.target] = json.translation.text;

        this.props.dispatch(this.props.updateTranslation(translation));
      })
      .catch(e => this.setState({ loading: false }));
  };

  getSupportedLanguages = async () => {
    const languageUrl = url + 'languages/';
    const target = this.props.source.substring(0, 2);

    const data = {
      target,
    };

    fetch(languageUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then((json) => {
        const supportedLanguages = json.translation.map(l => l.code);
        this.setState({ supportedLanguages });
      });
  };

  setTarget = target => this.setState({ target });

  renderLanguageOption = (language, index) => {
    const disabled =
      this.state.target === language ||
      this.props.source.substring(0, 2) === language;
    return (
      <MenuItem
        className="menu-language-option"
        key={index}
        value={language}
        disabled={disabled}
        label={languageNames[language] || language}
        primaryText={languageNames[language] || language}
      />
    );
  };

  render() {
    const { text } = this.props;

    const btnLabel = this.state.target
      ? `Translate to ${languageNames[this.state.target]}`
      : 'Translate';

    const disabled =
      this.state.loading || this.state.supportedLanguages.length === 0;

    let translation = '';

    if (
      text.texts[text.activeText].translations &&
      text.texts[text.activeText].translations[this.state.target]
    ) {
      translation = text.texts[text.activeText].translations[this.state.target];
    }

    return (
      <div>
        <div
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-end',
            justifyContent: 'center',
            marginBottom: '8px',
          }}
        >
          <SelectField
            id="pronounce-translation-language-menu"
            className="pronounce-language-menu"
            style={{ position: 'absolute', left: 0, width: '200px' }}
            autoWidth
            disabled={disabled}
            value={this.state.target}
            onChange={(e, index, value) => this.setTarget(value)}
          >
            {this.state.supportedLanguages.map(this.renderLanguageOption)}
          </SelectField>
          <RaisedButton
            label={btnLabel}
            style={{ textAlign: 'center' }}
            disabled={disabled}
            onTouchTap={this.translate}
          />
        </div>
        <div className="card" style={{ padding: '4px' }}>
          <div
            style={{
              padding: '8px',
              textAlign: 'center',
              fontSize: '18px',
              minHeight: '23px',
            }}
          >
            {this.state.loading && <CircularProgress size={20} />}
            {translation && <span>{translation}</span>}
          </div>
        </div>
          <img
            style={{ width: '200px', paddingTop: '4px', textAlign: 'center' }}
            src="/images/google/greyscale-regular@3x.png"
            alt="Translated by Google"
          />
      </div>
    );
  }
}

export default Translation;



// WEBPACK FOOTER //
// ./src/components/Translation.js